import modelBaseV2 from "../model-base-v2.model";


const DeactivationIMEISelloutModel = {
  checkAccess: (deactivationType) => {
    return modelBaseV2.get("/api/deactivation/authCheck", {
      params: { deactivationType },
    });
  },

  downloadResult: (fileId, filename) => {
    return modelBaseV2.getDownload(
      "/api/file/temp/:fileId",
      {
        params: { fileId },
      },
      filename
    );
  },

  deactivate: (data) => {
    return modelBaseV2.post("/api/deactivation/IMEISODeactivationWeb", {
      body: data,
    });
  },

  getBackDayLimit: (deactivationType) => {
    return modelBaseV2.get("/api/deactivation/backDayLimit", {
      params: { deactivationType },
    });
  },
};


export default DeactivationIMEISelloutModel;